module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/18-8bb261367a6e9bc90d73daf0c10badff.jpg";